import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Briefcase, MessageSquare, Star } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();
  const whatsappLink = "https://chat.whatsapp.com/DkvPVnLDNfXJC8w1uBZAGO";
  const googleReviewLink = "https://g.page/r/CSppBr1ncMe8EBM/review";
  
  const footerLinkColumns = [
    {
      title: t('footer.quickLinks'),
      links: [
        { name: t('nav.home'), path: '/' },
        { name: t('nav.menu'), path: '/menu' },
        { name: t('nav.catering'), path: '/catering' },
        { name: t('nav.marketDay'), path: '/market-day' },
        { name: t('nav.contact'), path: '/contact' },
      ]
    }
  ];

  return (
    <footer className="bg-gray-800 text-gray-300 border-t-4 border-primary">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-10">
          <div className="md:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center text-3xl font-bold text-white mb-4">
              <img src="/images/amsfoodmarket-logo.png"alt="Ams Food Market Logo" className="h-12 mr-3" />
              Ams Food Market
            </Link>
            <p className="text-gray-400 mb-6 max-w-md">
              {t('footer.description')}
            </p>
            <div className="space-y-3">
              <p className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 mt-1 text-primary shrink-0" />
                <span>{language === 'nl' ? 'Griend 36-15, 8225 TE Lelystad, Nederland' : 'Griend 36-15, 8225 TE Lelystad, The Netherlands'}</span>
              </p>
              <p className="flex items-center">
                <Phone className="h-5 w-5 mr-3 text-primary shrink-0" />
                <a href="tel:0641111632" className="hover:text-white transition-colors">064 111 1632</a>
              </p>
              <p className="flex items-center">
                <Mail className="h-5 w-5 mr-3 text-primary shrink-0" />
                <a href="mailto:amsfoodmarket@hotmail.com" className="hover:text-white transition-colors">amsfoodmarket@hotmail.com</a>
              </p>
              <p className="flex items-center">
                <Briefcase className="h-5 w-5 mr-3 text-primary shrink-0" />
                <span>{language === 'nl' ? 'KVK: 87975858' : 'Chamber of Commerce: 87975858'}</span>
              </p>
            </div>
          </div>
          
          {footerLinkColumns.map((column, index) => (
            <div key={index}>
              <h4 className="font-semibold text-white mb-4 text-lg">{column.title}</h4>
              <ul className="space-y-3">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link 
                      to={link.path} 
                      className="text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-semibold text-white mb-4 text-lg">{t('footer.stayConnected')}</h4>
            <ul className="space-y-3">
              <li>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-400 hover:text-white transition-colors text-sm">
                  <MessageSquare className="h-4 w-4 mr-2 text-green-400" /> {t('footer.whatsapp')}
                </a>
              </li>
              <li>
                <a href={googleReviewLink} target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-400 hover:text-white transition-colors text-sm">
                  <Star className="h-4 w-4 mr-2 text-yellow-400" /> {t('footer.googleReview')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            {t('footer.copyright', { currentYear: currentYear })}
          </p>
          <a href="https://www.lvswebdesign.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">
            {t('footer.poweredBy')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;